import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getTravauxTertiaireStub } from '../../../../config/travaux-tertiaire';

export default function TertiaireIsolationToiturePage() {
  const parcours = getTravauxTertiaireStub('isolation-toiture');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="tertiaire"
      segment="travaux"
      segmentLabel="Travaux"
      crossLinks={[
        {
          label: 'CEE BAT-* tertiaire',
          href: '/tertiaire/aides/cee-bat',
          iconName: 'sparkles',
          hint: "Prime CEE pour la fiche BAT-EN-101",
        },
        {
          label: 'Audit OPERAT',
          href: '/tertiaire/decret-tertiaire',
          iconName: 'gauge',
          hint: "Hiérarchisation de l'isolation dans le plan -40 %",
        },
        {
          label: 'Prêts Bpifrance climat',
          href: '/tertiaire/aides/prets-bpifrance',
          iconName: 'banknote',
          hint: 'Financement réfection + isolation',
        },
      ]}
      crossLinksAllLabel="Voir toutes les aides tertiaire"
      crossLinksAllHref="/tertiaire/aides"
    />
  );
}
